/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consent_State_DeniedInputs */

const en_consent_state_denied = /** @type {(inputs: Consent_State_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your current choice: analytics rejected.`)
};

/**
* | output |
* | --- |
* | "Your current choice: analytics rejected." |
*
* @param {Consent_State_DeniedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const consent_state_denied = /** @type {((inputs?: Consent_State_DeniedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consent_State_DeniedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_consent_state_denied(inputs)
});